import { render } from "./ModalCustom.vue?vue&type=template&id=5f320068"
import script from "./ModalCustom.vue?vue&type=script&lang=js"
export * from "./ModalCustom.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__